<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">综合查询:</div>
                <el-input v-model="conditionData.Multiple" size="small" placeholder="请输入"></el-input>
            </div>
           
            <div class="item">
                <div class="label">开始日期:</div>
                <el-date-picker
                v-model="conditionData.StartTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="item">
                <div class="label">结束日期:</div>
                <el-date-picker
                v-model="conditionData.EndTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="item">
                <div class="label">案件类型:</div>
                <el-select v-model="conditionData.FinanceState" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in StatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            
            <div class="item">
                <div class="label">是否已结算:</div>
                <el-select v-model="conditionData.IsEndCount" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in IsEndCountList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            
          
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="success" icon="el-icon-download" size="small" @click="getExcel">导出excel</el-button>
                    <!-- <el-button type="primary" icon="el-icon-edit" size="small" @click="updateDialogShow()">修改人员信息</el-button> -->
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="550"
                style="width: 100%">
                
                <el-table-column
                prop="caseNo"
                label="案件ID"
                align="center"
                width="240"
                >
                </el-table-column>
                <el-table-column
                prop="creationTime"
                label="案件创建时间"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="serviceName"
                label="服务人员姓名"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="mechanismName"
                label="机构"
                align="center"
                width="220"
                >
                </el-table-column>
                 <el-table-column
                prop="companyName"
                label="保险公司"
                align="center"
                width="220"
                
                >
                </el-table-column>
                <el-table-column
                prop="startTime"
                label="所属派驻月份"
                align="center"
                width="160"
                >
                </el-table-column>
                <!-- <el-table-column
                prop="endTime"
                label="服务截至时间"
                align="center"
                width="220"
                >
                </el-table-column> -->
                <el-table-column
                prop="casesFei"
                label="公估费用"
                align="center"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="actualCost"
                label="实际公估费用"
                align="center"
                width="120"
                >
                </el-table-column>
                <el-table-column
                prop="state"
                label="状态"
                align="center"
                width="180"
                >
                <template slot-scope="scope">
                    <!-- <span v-if="scope.row.financeState==50">已开票未回款</span>
                    <span v-if="scope.row.financeState==55">已开票部分回款</span>
                    <span v-if="scope.row.financeState==60">回款完成</span>
                    <span v-if="scope.row.financeState==65">已回款未开票</span>
                    <span v-if="scope.row.financeState==0">其他</span>
                    <span v-if="scope.row.financeState==70">红冲</span>
                    <span v-if="scope.row.financeState==75">作废</span> -->

                    <span v-if="scope.row.financeState==0">未开票未回款</span>
                    <span v-if="scope.row.financeState==1">未完成未开票</span>
                    <span v-if="scope.row.financeState==2">已完成未开票</span>
                    <span v-if="scope.row.financeState==10">已开票未回款</span>
                    <span v-if="scope.row.financeState==20">已开票部分回款</span>
                    <span v-if="scope.row.financeState==30">回款完成</span>
                    <span v-if="scope.row.financeState==40">回款未开票</span>
                    <span v-if="scope.row.financeState==50">红冲</span>
                    <span v-if="scope.row.financeState==60">作废</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="invoiceNumber"
                label="发票号"
                align="center"
                width="200"
                >
                </el-table-column>
                
                
                
                <el-table-column
                prop="isEndCount"
                label="是否结算"
                align="center"
                width="100"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.isEndCount==0">未结算</span>
                    <span v-if="scope.row.isEndCount==1">已结算</span>
                </template>
                </el-table-column>

                <el-table-column
                prop="standName"
                label="立项名称"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="outRemarks"
                label="备注"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="330px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-search" size="mini" @click="detail(scope.row)">查看详情</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCase(scope.row)" v-if="isHandle=='1'">删除</el-button>
                    <el-button type="text" icon="el-icon-search" size="mini" @click="relevanceDetail(scope.row)">查看关联立项</el-button>
                    <el-button type="text" icon="el-icon-date" size="mini" @click="dailyList(scope.row)">查看日志</el-button>
                </template>
                </el-table-column>
            </el-table>


            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next,total"
                    :total="totalCount"
                    :current-page="conditionData.pageIndex"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        <el-dialog :close-on-click-modal="false" :visible.sync="isDetailDialog" title="案件详情" width="860px">
            <div class="dialog">
                <div class="item">
                    <div class="label">案件ID:</div>
                    <el-input v-model="detailData.caseNo" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">创建时间:</div>
                    <el-input v-model="detailData.creationTime" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">服务人员姓名:</div>
                    <el-input v-model="detailData.serviceName" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">机构:</div>
                    <el-input v-model="detailData.mechanismName" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">保险公司:</div>
                    <el-input v-model="detailData.companyName" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">所属派驻月份:</div>
                    <el-input v-model="detailData.startTime" size="small" placeholder="" style="width:250px"></el-input>
                </div>

                
                <div class="item">
                    <div class="label">公估费用:</div>
                    <el-input v-model="detailData.casesFei" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">实际公估费用:</div>
                    <el-input v-model="detailData.actualCost" size="small" placeholder="" style="width:250px"></el-input>
                </div>

                <div class="item">
                    <div class="label">状态:</div>
                    <el-select v-model="detailData.financeState" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in StatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="item">
                    <div class="label">发票号:</div>
                    <el-input v-model="detailData.invoiceNumber" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">是否结算:</div>
                    <el-select v-model="detailData.isEndCount" size="small" placeholder="请选择">
                        <el-option
                        v-for="item in IsEndCountList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="item">
                    <div class="label">立项名:</div>
                    <el-input v-model="detailData.standName" size="small" placeholder="" style="width:250px"></el-input>
                    
                </div>
               
                <div class="item item-textarea">
                    <div class="label">备注:</div>
                    <el-input type="textarea" v-model="detailData.outRemarks" size="small" placeholder="" style="width:640px"></el-input>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isRelevanceDetail" title="查看关联立项" width="1600px">
            <el-table
                :data="invoiceList"
                border
                :header-cell-style="tableHeaderColor"
                height="550"
                style="width: 100%">
                <el-table-column
                prop="standProjectId"
                width="110"
                label="立项ID"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="立项名称"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="invoiceNo"
                label="发票号"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="invoiceCode"
                label="发票编码"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                prop="invoicePrice"
                label="发票金额"
                align="center"
                width="120"
                
                >
                </el-table-column>
                <el-table-column
                prop="actualPrice"
                label="实际收金额"
                align="center"
                width="120"
                >
                </el-table-column>
                <el-table-column
                prop="company"
                label="公司"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="companyCodeName"
                label="委托公司全称"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop=""
                label="状态"
                align="center"
                width="200"
                
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.financeState==1">已开票未回款</span>
                    <span v-if="scope.row.financeState==2">已开票部分回款</span>
                    <span v-if="scope.row.financeState==3">回款完成</span>
                    <span v-if="scope.row.financeState==4">已回款未开票</span>
                    <span v-if="scope.row.financeState==7">红冲</span>
                    <span v-if="scope.row.financeState==8">作废</span>
                    <span v-if="scope.row.financeState==5">其他</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="invoicingTime"
                label="开票时间"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="creatTime"
                label="创建时间"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <!-- <el-table-column
                fixed="right"
                label="操作"
                width="150px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-search" size="mini" @click="relevanceItemDetail(scope.row)">查看详情</el-button>
                </template>
                </el-table-column> -->
            </el-table>
            <div class="page">
                <el-pagination
                    @current-change="handleCurrentInvoiceChange"
                    background
                    layout="prev, pager, next ,sizes ,total"
                    :total="invoiceCount"
                    :current-page="conditionInvoiceData.pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="conditionInvoiceData.pageSize">
                </el-pagination>
                
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isDailyDialog" title="查看日志" width="800px">
            <el-timeline>
                <el-timeline-item :timestamp="item.cDateTime" placement="top" v-for="(item,index) in daily" :key="index">
                <p> 
                    {{item.behavior==0?'插入':''}}
                    {{item.behavior==1?'更新':''}}
                    {{item.behavior==2?'单个关联':''}}
                    {{item.behavior==3?'批量关联':''}}
                    {{item.behavior==4?'取消关联':''}}
                </p>
                </el-timeline-item>
               
            </el-timeline>
        </el-dialog>
        
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeS,parseTimeD} from '../../../utils/index'
import {claimsStandTermStatus,carTypeList,companyTypeList,businessModuleList,moduleList} from '../../../assets/selectList/assetsSelectList'
export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            time:'',
            title:'',
            isDetailDialog:false,
            totalCount:0,
            conditionData:{
                FinanceState:null,
                IsEndCount:null,
                Multiple:"",
                StartTime:"",
                EndTime:"",
                pageIndex:1,
                pageSize:20,
            },
            IsEndCountList:[
                {
                    label:'全部',
                    value:null,
                },
                {
                    label:'未结算',
                    value:0,
                },{
                    label:'已结算',
                    value:1,
                },
            ],
            tableData:[],
            detailData:{},
            StatusList:claimsStandTermStatus,
            categoryList:[
                {
                    label:'全部',
                    value:null,
                },{
                    label:'默认案件',
                    value:'默认案件',
                },{
                    label:'医事案件',
                    value:'医事案件',
                }
            ],

            isRelevanceDetail:false,

            conditionInvoiceData:{
                RelationID:null,
                IsJoinCase:null,
                Multiple:"",
                financeState:null,
                StartTime:"",
                EndTime:"",
                CompanyName:"",
                pageIndex:1,
                pageSize:10,
            },
            invoiceList:[],
            invoiceCount:0,
            row:null,

            isDailyDialog:false,
            daily:[
                
            ],
            isHandle:localStorage.getItem('isHandle')
        }
    },
    created(){
        

    },
    mounted(){
        this.loadingData();
    },
    methods:{
        async dailyList(row){
            this.isDailyDialog = true;
            let res = await api.externalQueryCaseLogs({
                "caseID": row.caseNo,
                "caseType": 5
            });
            this.daily = res.data.data;
        },
        handleCurrentInvoiceChange(pageIndex){
            this.conditionInvoiceData.pageIndex = pageIndex;
            this.relevanceDetail(this.row);
        },
        async relevanceDetail(row){
            console.log(row);
            this.row = row;
            this.isRelevanceDetail = true;
            this.conditionInvoiceData.RelationID = row.relatedID;
            let res  = await api.getClaimsList(this.conditionInvoiceData);
            this.invoiceList = res.data.data.entitys;
            this.invoiceCount = res.data.data.pageLen;
            for(let i in this.invoiceList){
                this.invoiceList[i].billingTimeStr = parseTimeD(this.invoiceList[i].billingTime)
            }
        },
        relevanceItemDetail(row){
            localStorage.setItem('editData',JSON.stringify(row));
            const { href } = this.$router.resolve({
                name: "carInsuranceDetail",
                query:{
                    id:row.standProjectId,
                    isDetail:true,
                }
            });
            window.open(href, '_blank');
        },


        async deleteCase(row){
            console.log(row);
            this.$confirm('是否删除此数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteCaseFun(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        async deleteCaseFun(row){
            let res  = await api.deleteClaims(row.id);
            if(res.data.code == 200){
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            if(this.time){
                this.conditionData.StartTime = parseTimeD(this.time[0]);
                this.conditionData.EndTime = parseTimeD(this.time[1]);
            }
            let res  = await api.queryClaims(this.conditionData);
            this.tableData = res.data.data.entitys;
            this.totalCount = res.data.data.pageLen;
            for(let i in this.tableData){
                this.tableData[i].dispatchingTime = parseTimeD(this.tableData[i].dispatchingTime)
                this.tableData[i].caseEndTime = parseTimeD(this.tableData[i].caseEndTime)
                this.tableData[i].startTime = parseTimeD(this.tableData[i].startTime)
                
            }
        },
        selectData(){
            this.conditionData.pageIndex = 1;
            this.loadingData();
        },
        reset(){
            this.time = '';
            this.conditionData = {
                FinanceState:null,
                IsEndCount:null,
                Multiple:"",
                StartTime:"",
                EndTime:"",
                pageIndex:1,
                pageSize:20,
            },
            this.loadingData();
        },
        handleCurrentChange(pageIndex){
            this.conditionData.pageIndex = pageIndex;
            this.loadingData();
        },
        
        detail(row){
            this.detailData = row;
            this.isDetailDialog = true;
        },
        async getExcel(){
            // let exportData = {
            //     Multiple:this.conditionData.Multiple,
            //     StartTime:this.conditionData.StartTime,
            //     EndTime:this.conditionData.EndTime,
            //     Status:this.conditionData.Status,
            //     Company:this.conditionData.Company,
            //     StandID:this.conditionData.StandID,
            //     IsEndCount:this.conditionData.IsEndCount,
            //     MechanismName:this.conditionData.MechanismName,
            //     ServiceName:this.conditionData.ServiceName,
            //     StandName:this.conditionData.StandName,
            //     PageIndex:'',
            //     PageSize:'',
            // }
            // let res = await api.exportClaims(exportData);
            let option = {
                Multiple:this.conditionData.Multiple,
                StartTime:this.conditionData.StartTime,
                EndTime:this.conditionData.EndTime,
                IsEndCount:this.conditionData.IsEndCount,
                financeState:this.conditionData.financeState,
            }
            let res = await api.claimsStandExport(option);
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 8px 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 7px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                min-width: 110px;
                margin-bottom: 5px;
            }
        }
        .item-textarea{
            width: 760px;
        }
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
